import React, { useReducer } from "react";

import StoreReducer from "./StoreReducer";
export const StoreContext = React.createContext([]);
export const StoreProvider = ({ children }) => {
  const initialState = {
    otpGenerate: {},
    otpVerify: {},
    user: {},
    userContact: {
      company: "",
      concern: "",
      contactNumber: "",
      emailAddress: "",
      fullName: "",
      mallBranch: "",
      message: ""
    }
  };
  const [state, dispatch] = useReducer(StoreReducer, initialState);

  return (
    <StoreContext.Provider value={[state, dispatch]}>
      {children}
    </StoreContext.Provider>
  );
};
